"use strict";
import { ApolloClient, ApolloLink, Observable } from "@apollo/client";
import { setupSharedApolloCache } from "data/cache";
const noopLink = new ApolloLink(
  () => new Observable((observer) => {
    observer.next({ data: {} });
    observer.complete();
  })
);
export const apolloClient = new ApolloClient({
  connectToDevTools: true,
  link: noopLink,
  cache: setupSharedApolloCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-first"
    }
  }
});
